// stores/cameras.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import axios from 'axios'
import { useAuthStore } from './auth'

export const useCamerasStore = defineStore('cameras', () => {
  const authStore = useAuthStore()
  
  const cameras = ref([])
  const loading = ref(false)
  const error = ref(null)
  const selectedCamera = ref(null)
  
  const API_BASE_URL = import.meta.env.VITE_API_URL || (window.location.origin)
  
  const filteredCameras = computed(() => {
    if (!cameras.value.length) return []
    
    const userSource = authStore.userSource
    if (userSource === 'all' || !userSource) {
      return cameras.value
    }
    return cameras.value.filter(c => c.source === userSource || c.source_name === userSource)
  })
  
  async function fetchCameras() {
    loading.value = true
    error.value = null
    
    try {
      
      const response = await axios.get(`${API_BASE_URL}/api/cameras`, {
        headers: { 
          Authorization: `Bearer ${authStore.token}`,
          'Content-Type': 'application/json'
        },
        timeout: 10000
      })
      
      
      if (response.data && response.data.success && response.data.cameras) {
        cameras.value = response.data.cameras.map(cam => ({
          ...cam,
          id: cam.id || cam._id || cam.name,
          // Normalize URL
          url: cam.url || cam.stream_url || cam.rtsp_url || cam.hls_url || '',
          // Normalize format
          format: cam.format || (cam.url?.includes('.m3u8') ? 'hls' : 'mp4'),
          // Add source info
          source: cam.source || cam.source_name || cam.site || 'unknown',
          location: cam.location || cam.site || 'Unknown'
        }))
        
        
        // Log first camera for debugging
        if (cameras.value.length > 0) {
        }
        
        return cameras.value
      } else {
        console.warn('⚠️ Invalid cameras response:', response.data)
        cameras.value = []
      }
    } catch (err) {
      console.error('❌ Failed to fetch cameras:', err.message)
      error.value = err.message
      cameras.value = []
    } finally {
      loading.value = false
    }
  }
  
  function selectCamera(camera) {
    selectedCamera.value = camera
  }
  
  function clearSelectedCamera() {
    selectedCamera.value = null
  }
  
  return {
    cameras,
    loading,
    error,
    selectedCamera,
    filteredCameras,
    fetchCameras,
    selectCamera,
    clearSelectedCamera
  }
})